var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"width":"70px","height":"70px"},attrs:{"viewBox":"0 0 70 70"}},[_c('path',{attrs:{"fill":"none","stroke-width":_vm.weight,"stroke":_vm.color,"d":`M ${_vm.size / 2 + _vm.radius},${
      _vm.size / 2
    } A ${_vm.radius},${_vm.radius} 0 ${_vm.largeArcFlag},1 ${_vm.x},${_vm.y}`}}),_c('path',{attrs:{"fill":"none","stroke-width":_vm.weight,"stroke":_vm.fadeColor,"d":`M ${_vm.size / 2 + _vm.radius},${
      _vm.size / 2
    } A ${_vm.radius},${_vm.radius} 0 ${_vm.fadeLargeArcFlag},0 ${_vm.x},${_vm.y}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }